import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yaz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getToken = () => localStorage.getItem("yaz_token");

export const CATEGORIES = ["Emergency", "Safety", "Venue", "Events", "General"];

export const CATEGORY_STYLE = {
  Emergency: { bg: "#FF3B30", text: "#fff", label: "EMERGENCY" },
  Safety: { bg: "#FFCC00", text: "#000", label: "SAFETY" },
  Venue: { bg: "#00F0FF", text: "#000", label: "VENUE" },
  Events: { bg: "#FF007F", text: "#fff", label: "EVENTS" },
  General: { bg: "#27272A", text: "#fff", label: "GENERAL" },
};

export const PRIORITIES = ["critical", "high", "normal", "low"];
